import { render } from "./UiBackButton.vue?vue&type=template&id=b2b27346&ts=true"
import script from "./UiBackButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiBackButton.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiBackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2b27346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2b27346', __exports__)) {
    api.reload('b2b27346', __exports__)
  }
  
  module.hot.accept("./UiBackButton.vue?vue&type=template&id=b2b27346&ts=true", () => {
    api.rerender('b2b27346', render)
  })

}


export default __exports__